module.exports = __webpack_public_path__ + "static/img/cw-1.b738db2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/cw-1.jpg
 ** module id = 575
 ** module chunks = 2
 **/